import { FormHelperText, Typography } from "@mui/material";
import Autocomplete from "@components/Autocomplete/Autocomplete";
import { t } from "i18next";
import { usePortServicesFlow } from "../context/PortServicesFlowContext";
import { OPERATION_TYPE_OPTIONS } from "./constants";

const LANG_BASE = "vessel-call.port-services";

const OperationType = () => {
  const { setOperationType, errors, setErrors } = usePortServicesFlow();

  return (
    <div className="flex flex-col gap-2" data-testid="port-services-operation-type">
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {t(`${LANG_BASE}.fields.operation-type`)}
      </Typography>
      <Autocomplete
        options={OPERATION_TYPE_OPTIONS}
        placeholder={t(`${LANG_BASE}.fields.operation-type`)}
        onChange={(option) => {
          setOperationType(option?.value ? String(option.value) : "");
          if (errors.operationType) {
            setErrors({ ...errors, operationType: undefined });
          }
        }}
        testId="port-services-operation-type"
      />
      {errors.operationType && (
        <FormHelperText sx={{ color: "error.main", m: 0 }}>{errors.operationType}</FormHelperText>
      )}
    </div>
  );
};

export default OperationType;
